import { all, takeLatest } from 'redux-saga/effects';
import librarySaga from './containers/library/library-saga';
import filterSaga from './containers/filter/filter-saga';

function* mainSaga() {
    yield all([
        takeLatest('FETCHING_LIBRARY_ITEMS', librarySaga),
        takeLatest('FETCH_COUNTRY_SPEC', filterSaga)
    ]);
}

export default mainSaga;
